/* bwx-mnav: mobile menu sub panels. Open/close of the drawer stays in header-script.min.js (SidebarController). */
(function () {
  function init() {
    var root = document.querySelector('.bwx-mnav');
    if (!root || root.getAttribute('data-mnav-ready')) return;
    root.setAttribute('data-mnav-ready', '1');
    var drawer = root.querySelector('.bwx-mnav__drawer');
    var rootPanel = root.querySelector('[data-mnav-root]');
    var backBtn = root.querySelector('[data-mnav-back]');
    var closeBtn = root.querySelector('.js-sidebar-close');
    var current = null;

    /* Size to the visible width, so a wider layout viewport (page overflow) never clips the drawer */
    function fit() {
      var w = document.documentElement.clientWidth || window.innerWidth;
      drawer.style.maxWidth = Math.min(440, w) + 'px';
    }
    fit();
    window.addEventListener('resize', fit);

    function openPanel(id, trigger) {
      var panel = document.getElementById(id);
      if (!panel) return;
      if (current && current !== panel) current.classList.remove('bwx-mnav-on');
      panel.scrollTop = 0;
      panel.classList.add('bwx-mnav-on');
      panel.setAttribute('aria-hidden', 'false');
      rootPanel.setAttribute('aria-hidden', 'true');
      drawer.classList.add('bwx-mnav--sub');
      current = panel;
      current._mnavTrigger = trigger || null;
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      setTimeout(function () { if (backBtn) backBtn.focus({ preventScroll: true }); }, 30);
    }

    function home(focus) {
      drawer.classList.remove('bwx-mnav--sub');
      rootPanel.setAttribute('aria-hidden', 'false');
      if (current) {
        current.classList.remove('bwx-mnav-on');
        current.setAttribute('aria-hidden', 'true');
        var t = current._mnavTrigger;
        if (t) {
          t.setAttribute('aria-expanded', 'false');
          if (focus) setTimeout(function () { t.focus({ preventScroll: true }); }, 30);
        }
      }
      current = null;
    }

    root.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-mnav-open]');
      if (opener && root.contains(opener)) {
        e.preventDefault();
        openPanel(opener.getAttribute('data-mnav-open'), opener);
        return;
      }
      if (e.target.closest('[data-mnav-back]')) {
        e.preventDefault();
        home(true);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !root.classList.contains('m-header-sidebar--visible')) return;
      if (current) { home(true); } else if (closeBtn) { closeBtn.click(); }
    });

    /* Reset to level 1 after the drawer closes */
    var wasOpen = root.classList.contains('m-header-sidebar--visible');
    new MutationObserver(function () {
      var isOpen = root.classList.contains('m-header-sidebar--visible');
      if (wasOpen && !isOpen) {
        setTimeout(function () {
          if (!root.classList.contains('m-header-sidebar--visible')) { home(false); rootPanel.scrollTop = 0; }
        }, 360);
      }
      if (!wasOpen && isOpen) {
        fit();
        drawer.setAttribute('aria-hidden', 'false');
      } else if (wasOpen && !isOpen) {
        drawer.setAttribute('aria-hidden', 'true');
      }
      wasOpen = isOpen;
    }).observe(root, { attributes: true, attributeFilter: ['class'] });
    drawer.setAttribute('aria-hidden', wasOpen ? 'false' : 'true');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 0); });
})();
